import { render, staticRenderFns } from "./IngredientStockMovementView.vue?vue&type=template&id=050ce093&scoped=true"
import script from "./IngredientStockMovementView.vue?vue&type=script&lang=js"
export * from "./IngredientStockMovementView.vue?vue&type=script&lang=js"
import style0 from "./IngredientStockMovementView.vue?vue&type=style&index=0&id=050ce093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ce093",
  null
  
)

export default component.exports